import React from 'react';

interface ComingSoonProps {
  icon: React.ElementType;
  label: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ icon: Icon, label }) => (
  <div className="flex flex-col items-center justify-center py-32 text-center">
    <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 bg-muted/50 border border-border">
      <Icon className="w-10 h-10 text-muted-foreground" />
    </div>
    <h2 className="text-2xl font-bold mb-3 text-foreground">{label}</h2>
    <p className="text-muted-foreground max-w-sm">This feature is coming soon to the AgencyPlus Dashboard.</p>
  </div>
);
